document.addEventListener("click", function (e) {
  let buyBtn = e.target.closest('.shopify-payment-button__button, .m-product-buy-now, [data-buy-now]');
  if (!buyBtn) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  console.log("BUY NOW INTERCEPTED 🔥");

  let { sleeve, length, feedingZip } = window.getSelectedValues();
  let mainVariantId = document.querySelector('input[name="id"]')?.value;
  let quantity = parseInt(document.querySelector('input[name="quantity"]')?.value) || 1;
  let selectedSize = document.querySelector('input[name="custom_size"]:checked')?.value || "";
  let linkId = Date.now().toString();
  let orderNote = document.querySelector('textarea[name="properties[Order Note:]"]')?.value || "";
  let productName = document.querySelector('.m-product-title, h1.product__title, h1')?.textContent?.trim() || "";

  let key = `${length}-${sleeve}-${feedingZip}`;
  let addonVariantId = window.variantMap[key];

  if (!addonVariantId) {
    alert("Variant not found");
    return;
  }

  fetch('/cart/clear.js', { method: 'POST' })
    .then(() => fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: mainVariantId,
            quantity: quantity,
            properties: {
              "Size": selectedSize,
              "Choose Dress Length": length,
              "Choose Sleeve Type": sleeve,
              "Feeding Zips": feedingZip,
              "Order Note": orderNote,
              "_link": linkId
            }
          },
          {
            id: addonVariantId,
            quantity: quantity,
            properties: {
              "_addon": "true",
              "_link": linkId,
              "Belongs to": "Customization for " + productName
            }
          }
        ]
      })
    }))
    .then(res => res.json())
    .then(data => {
      console.log("Buy Now - Added ✅", data);
      window.location.href = "/checkout";
    })
    .catch(err => console.error("Buy Now Error ❌", err));

}, true);